<template>
    <model-modal
        component="v-spa-mixed-modal"
        :model-class="modelClass"
        modal-type="form"
        @opened="onOpened"
        @resetted="onReset"
        ref="modal"
    >
        <template v-slot:default="slotProps">
            <div v-if="canDisplayTabsSwitch" class="flex mb-8">
                <a href="#" @click.prevent="switchTab('import_invoicing')" class="flex items-center pb-1 mr-6 font-medium" v-if="$spa.TrustUpPro.hasAccount('invoicing')">
                    <img :src="`${$spa.TrustUpPro.url}/apps/invoicing/icon.svg`" class="w-6 h-6 mr-2">
                    <span :class="tab == 'import_invoicing' ? 'text-primary border-b-2 border-primary' : 'gray-800'">
                        {{ $t('worksite.profitability.form.tab.invoicing') }}
                    </span>
                </a>
                <a href="#" @click.prevent="switchTab('import_timetracker')" class="flex items-center pb-1 mr-6 font-medium" v-if="types && $spa.TrustUpPro.hasAccount('timetracker')">
                    <img :src="`${$spa.TrustUpPro.url}/apps/timetracker/icon.svg`" class="w-6 h-6 mr-2">
                    <span :class="tab == 'import_timetracker' ? 'text-primary border-b-2 border-primary' : 'gray-800'">
                        {{ $t('worksite.profitability.form.tab.timetracker') }}
                    </span>
                </a>
                <a href="#" @click.prevent="switchTab('create')" class="inline-block pb-1 font-medium" :class="tab == 'create' ? 'text-primary border-b-2 border-primary' : 'text-gray-800'">
                    {{ $t('worksite.profitability.form.tab.manual') }}
                </a>
            </div>

            <div class="relative" :class="{'py-8': invoicing.loading}" v-if="tab == 'import_invoicing'">
                <v-spa-loader class-name="absolute inset-0 z-10 text-center" v-if="invoicing.loading"></v-spa-loader>
                <template v-else>
                    <form @submit.prevent="submitWithSelectedInvoicingDocument" v-if="invoicing.documents && invoicing.documents.length > 0">
                        <div class="mb-6">
                            <v-spa-label id="create-worksite-profitability-document-form-document" :label="$t('worksite.profitability.form.labels.select_import_document')"></v-spa-label>
                            <select v-model="invoicing.documentToImport" :class="$spa.css.form.select" id="create-worksite-profitability-document-form-document">
                                <option :value="document" v-for="document in invoicing.documents" :key="document.uuid">
                                    {{ invoicingDocumentLabel(document) }}
                                </option>
                            </select>
                        </div>
                        <v-spa-element id="create-worksite-profitability-document-form-type" :form="form" input-name="type" v-if="types" :label="$t('worksite.profitability.form.cost.labels.type')">
                            <select v-model="form.type" :class="$spa.css.form.select" id="create-worksite-profitability-document-form-type">
                                <option :value="documentType" v-for="documentType in types" :key="documentType">
                                    {{ $t(`worksite.profitability.cost_type.${documentType}`) }}
                                </option>
                            </select>
                        </v-spa-element>
                        <div class="flex justify-end max-w-input">
                            <v-spa-loading-button :loading="form.isLoading()">
                                {{ $t(`worksite.profitability.form.${type}.button`) }}
                            </v-spa-loading-button>
                        </div>
                    </form>
                    <div class="p-4 bg-white border border-gray-200 rounded cursor-pointer hover:shadow" v-else @click.prevent="tab = 'create'">
                        <p class="text-sm text-center text-gray-600">{{ $t('worksite.profitability.form.no_document_to_import') }}</p>
                    </div>
                </template>
            </div>

            <div class="relative" :class="{'py-8': timetracker.loading}" v-if="tab == 'import_timetracker'">
                <v-spa-loader class-name="absolute inset-0 z-10 text-center" v-if="timetracker.loading"></v-spa-loader>
                <template v-else>
                    <form @submit.prevent="submitWithSelectedTimetrackerDocument" v-if="timetracker.documents && timetracker.documents.length > 0">
                        <div class="mb-6">
                            <v-spa-label id="create-worksite-profitability-document-form-document" :label="$t('worksite.profitability.form.labels.select_import_document')"></v-spa-label>
                            <select v-model="timetracker.documentToImport" :class="$spa.css.form.select" id="create-worksite-profitability-document-form-document">
                                <option :value="document" v-for="document in timetracker.documents" :key="document.uuid">
                                    {{ timetrackerDocumentLabel(document) }}
                                </option>
                            </select>
                        </div>
                        <v-spa-element id="create-worksite-profitability-document-form-type" :form="form" input-name="type" v-if="types" :label="$t('worksite.profitability.form.cost.labels.type')">
                            <select v-model="form.type" :class="$spa.css.form.select" id="create-worksite-profitability-document-form-type">
                                <option :value="documentType" v-for="documentType in types" :key="documentType">
                                    {{ $t(`worksite.profitability.cost_type.${documentType}`) }}
                                </option>
                            </select>
                        </v-spa-element>
                        <div class="flex justify-end max-w-input">
                            <v-spa-loading-button :loading="form.isLoading()">
                                {{ $t(`worksite.profitability.form.${type}.button`) }}
                            </v-spa-loading-button>
                        </div>
                    </form>
                    <div class="p-4 bg-white border border-gray-200 rounded cursor-pointer hover:shadow" v-else @click.prevent="tab = 'create'">
                        <p class="text-sm text-center text-gray-600">{{ $t('worksite.profitability.form.no_document_to_import') }}</p>
                    </div>
                </template>
            </div>

            <div v-if="tab == 'create'">
                <form @submit.prevent="submit">
                    <template v-if="types">
                        <v-spa-element id="create-worksite-profitability-document-form-type" :form="form" input-name="type" v-if="types" :label="$t('worksite.profitability.form.cost.labels.type')">
                            <select v-model="form.type" :class="$spa.css.form.select" id="create-worksite-profitability-document-form-type">
                                <option :value="documentType" v-for="documentType in types" :key="documentType">
                                    {{ $t(`worksite.profitability.cost_type.${documentType}`) }}
                                </option>
                            </select>
                        </v-spa-element>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2 md:w-1/2">
                                <v-spa-input id="create-worksite-profitability-document-form-number" :form="form" input-name="number" :label="$t('worksite.profitability.form.cost.labels.number')"></v-spa-input>
                            </div>
                            <div class="w-full px-2 md:w-1/2">
                                <v-spa-price-input id="create-worksite-profitability-document-form-amount" :form="form" input-name="amount" :label="$t('worksite.profitability.form.cost.labels.amount')"></v-spa-price-input>
                            </div>
                        </div>
                    </template>

                    <template v-if="type == 'quote'">
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2 md:w-1/2">
                                <v-spa-input :label="$t('worksite.profitability.form.quote.labels.number')" id="create-worksite-profitability-document-form-number" :form="form" input-name="number"></v-spa-input>
                            </div>
                            <div class="w-full px-2 md:w-1/2">
                                <v-spa-price-input :label="$t('worksite.profitability.form.quote.labels.amount')" id="create-worksite-profitability-document-form-amount" :form="form" input-name="amount"></v-spa-price-input>
                            </div>
                        </div>
                    </template>

                    <template v-if="type == 'invoice'">
                        <v-spa-input :label="$t('worksite.profitability.form.invoice.labels.number')" id="create-worksite-profitability-document-form-number" :form="form" input-name="number"></v-spa-input>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2 md:w-1/2">
                                <v-spa-price-input :label="$t('worksite.profitability.form.invoice.labels.amount')"  id="create-worksite-profitability-document-form-amount" :form="form" input-name="amount"></v-spa-price-input>
                            </div>
                            <div class="w-full px-2 md:w-1/2">
                                <v-spa-element id="create-worksite-profitability-document-form-status" :form="form" input-name="status" :label="$t('worksite.profitability.form.invoice.labels.status')">
                                    <select v-model="form.status" :class="$spa.css.form.select" id="create-worksite-profitability-document-form-status">
                                        <option :value="status" v-for="status in ['sent', 'paid', 'overdue']" :key="status">
                                            {{ $t(`worksite.profitability.document_status.${status}`) }}
                                        </option>
                                    </select>
                                </v-spa-element>
                            </div>
                        </div>
                    </template>

                    <v-spa-file
                        :label="$t('worksite.profitability.form.labels.select_document')"
                        ref="pdfInput"
                        id="create-folder-form-pdf"
                        :form="form"
                        input-name="pdf"
                    ></v-spa-file>

                    <div class="flex items-center justify-between">
                        <div><slot name="cancel-button"></slot></div>
                        <v-spa-loading-button :loading="form.isLoading()">
                            {{ $t(`worksite.profitability.form.${type}.button`) }}
                        </v-spa-loading-button>
                    </div>
                </form>
            </div>
        </template>
    </model-modal>
</template>

<script>
    import Form from '~spa/classes/Form';
    import ModelModal from '@spa/apps/trustup-pro-base-js/components/Model/Modal';
    import WorksiteProfitabilityDocument from '@spa/apps/trustup-pro-worksite-js/models/WorksiteProfitabilityDocument';

    export default {
        components: {
            ModelModal
        },

        data() {
            return {
                modelClass: WorksiteProfitabilityDocument,
                invoicing: {
                    loading: false,
                    documents: null,
                    documentToImport: null,
                },
                timetracker: {
                    loading: false,
                    documents: null,
                    documentToImport: null,
                },
                type: null,
                worksite: null,
                tab: 'create',
                form: new Form({
                    number: '',
                    status: 'sent',
                    type: null,
                    amount: 0,
                    sent_at: '',
                    external_uuid: null,
                    external_account_uuid: null,
                    external_source: null
                })
            };
        },

        computed: {
            model()
            {
                return this.$refs.modal?.model || null;
            },
            
            canDisplayTabsSwitch()
            {
                return ! this.model && (this.$spa.TrustUpPro.hasAccount('invoicing') || this.$spa.TrustUpPro.hasAccount('timetracker'));
            },

            types()
            {
                return this.type == 'cost'
                    ? ['purchase-invoice', 'labor', 'subcontracting', 'other-cost']
                    : null;
            }
        },
        
        methods: {
            onOpened(data)
            {
                this.worksite = data.worksite;
                this.type = this.model ? this.model.type : data.type;
                this.form.sent_at = window.moment().format('YYYY-MM-DD');
            
                if ( this.type ) {
                    this.form.type = this.type;
                }

                if ( this.types ) {
                    this.form.type = this.types[0];
                }

                if ( this.model ) {
                    this.form.fill( this.model );
                }

                if ( this.canDisplayTabsSwitch ) {
                    if ( this.$spa.TrustUpPro.hasAccount('invoicing') ) {
                        return this.switchTab('import_invoicing');
                    }

                    if ( this.$spa.TrustUpPro.hasAccount('timetracker') ) {
                        return this.switchTab('import_timetracker');
                    }
                }
            },

            onReset()
            {
                this.form.reset();
                this.form.stop();
                this.type = null;
                this.worksite = null;
                this.invoicing = {
                    loading: false,
                    documents: null,
                    documentToImport: null,
                };
                this.timetracker = {
                    loading: false,
                    documents: null,
                    documentToImport: null,
                };
            },

            switchTab(tab)
            {
                this.tab = tab;

                if ( this.tab == 'import_invoicing' && this.invoicing.documents == null ) {
                    if ( this.types ) {
                        this.form.type = this.types[0];
                    }
                    
                    this.invoicing.loading = true;
                    this.getInvoicingImportableDocuments()
                        .then(() => this.invoicing.loading = false);
                }

                if ( this.tab == 'import_timetracker' && this.timetracker.documents == null ) {
                    if ( this.types ) {
                        this.form.type = this.types[1];
                    }

                    this.timetracker.loading = true;
                    this.getTimetrackerImportableDocuments()
                        .then(() => this.timetracker.loading = false);
                }
            },
            
            submit() {
                if ( this.form.isLoading() ) {
                    return;
                }
                
                this.form.load();

                let data = this.form.asFormData();
                
                data.append('worksite_id', this.worksite.id);
                if ( this.$refs.pdfInput && this.$refs.pdfInput.file ) {
                    data.append('pdf_file', this.$refs.pdfInput.file);
                }

                let method = this.model ? 'update' : 'store';
                if ( this.model ) {
                    data = {
                        data: data,
                        uuid: this.model.uuid
                    }
                }
                
                window.Worksite.endpoints.worksiteProfitabilityDocument
                    .setWorksite(this.worksite)
                    [method](data)
                    .then(profitabilityDocument => {
                        this.$refs.modal.close();
                    })
                    .catch((error) => {
                        console.error(error);
                        this.form.onFail(error);
                    });
            },

            submitWithSelectedInvoicingDocument()
            {
                if ( ! this.invoicing.documentToImport ) {
                    return;
                }

                this.form.pdf = this.invoicing.documentToImport.pdf;  
                this.form.number = this.invoicing.documentToImport.number;  
                this.form.external_uuid = this.invoicing.documentToImport.uuid;  
                this.form.external_account_uuid = this.$spa.TrustUpPro.getAccountUuid('invoicing');
                this.form.external_source = 'invoicing';

                if ( ! this.type || this.type == 'cost' ) {    
                    this.form.status = 'paid';
                    this.form.amount = this.invoicing.documentToImport.price;
                    this.form.sent_at = window.moment(this.invoicing.documentToImport.created_at).format('YYYY-MM-DD');               
                } else {
                    this.form.status = this.invoicing.documentToImport.status_key;
                    this.form.amount = this.invoicing.documentToImport.subtotal;
                    this.form.sent_at = window.moment(this.invoicing.documentToImport.sent_at).format('YYYY-MM-DD');           
                }
                
                return this.submit();      
            },

            submitWithSelectedTimetrackerDocument()
            {
                if ( ! this.timetracker.documentToImport ) {
                    return;
                }

                this.form.number = `${this.timetracker.documentToImport.title} (${this.$moment(this.timetracker.documentToImport.starts_at).format('DD MMMM YYYY')} ${this.$moment(this.timetracker.documentToImport.starts_at).format('HH[h]mm')} - ${this.$moment(document.ends_at).format('HH[h]mm')})`;
                this.form.external_uuid = this.timetracker.documentToImport.uuid;  
                this.form.external_account_uuid = this.$spa.TrustUpPro.getAccountUuid('timetracker');
                this.form.external_source = 'timetracker';
                this.form.amount = this.timetracker.documentToImport.total.cost;
                this.form.sent_at = window.moment(this.timetracker.documentToImport.created_at).format('YYYY-MM-DD');           
                
                return this.submit();     
            },

            invoicingDocumentLabel(document)
            {
                let label = document.number ? `${document.number} - ` : '';

                if ( this.type && this.type !== 'cost' ) {
                    label += `${document.client_name} - ${window.centsToPrice(document.subtotal)}`;
                    if ( this.worksite.containsExternalProfitabilityDocument(document.uuid) ) {
                        label += ' (Déjà importé)';
                    }
                    return label;
                }

                label += `${document.title} - ${window.centsToPrice(document.price)}`;
                if ( this.worksite.containsExternalProfitabilityDocument(document.uuid) ) {
                    label += ' (Déjà importé)';
                }
                return label;
            },

            timetrackerDocumentLabel(document)
            {
                let label = `${document.title} (${this.$moment(document.starts_at).format('DD MMMM YYYY')} ${this.$moment(document.starts_at).format('HH[h]mm')} - ${this.$moment(document.ends_at).format('HH[h]mm')})`;
                
                if ( document.total && document.total.cost ) {
                    label += ` - ${window.centsToPrice(document.total.cost)}`;
                }

                if ( this.worksite.containsExternalProfitabilityDocument(document.uuid) ) {
                    label += ' (Déjà importé)';
                }

                return label;
            },

            async getInvoicingImportableDocuments()
            {
                let method = 'getReceipts';
                let params = {type: 'invoice'};

                if ( this.type == 'quote' ) {
                    method = 'getQuotes';
                    params = {};
                }

                if ( this.type == 'invoice' ) {
                    method = 'getInvoices';
                    params = {};
                }

                console.log(method, params);

                let documents = await this.$spa.TrustUpPro[method](params);
                this.invoicing.documents = documents || [];
                if ( method !== 'getReceipts' ) {
                    this.invoicing.documents = this.invoicing.documents.filter(d => d.number !== null);
                }
                if ( this.invoicing.documents.length > 0 ) {
                    this.invoicing.documentToImport = this.invoicing.documents[0];
                }
            },

            async getTimetrackerImportableDocuments()
            {
                let {activities} = await window.Planning.endpoints.timeActivity.table({worksites: this.worksite.uuid});
                this.timetracker.documents = activities?.items || [];
                if ( this.timetracker.documents.length > 0 ) {
                    this.timetracker.documentToImport = this.timetracker.documents[0];
                }
            }
        }
    }
</script>